import { render, staticRenderFns } from "./OilConsumption.vue?vue&type=template&id=45261bce&scoped=true&"
import script from "./OilConsumption.vue?vue&type=script&lang=js&"
export * from "./OilConsumption.vue?vue&type=script&lang=js&"
import style0 from "./OilConsumption.vue?vue&type=style&index=0&id=45261bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45261bce",
  null
  
)

export default component.exports